<template>
  <div>
    <v-app-bar app flat class="app-bar white px-2">
      <router-link to="/">
        <v-toolbar-title>
          <v-img src="@/assets/images/header.svg" />
        </v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
      <v-btn icon @click="onSearchClicked">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-app-bar-nav-icon @click="onDrawerClicked"></v-app-bar-nav-icon>

      <template v-slot:extension v-if="searchBarVisible">
        <SearchBar @searchFinished="onSearchFinished" class="mt-5" />
      </template>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      right
      class="app-drawer grey lighten-3"
      width="400"
    >
      <template v-slot:prepend>
        <div class="drawer-header d-flex flex-row justify-end pa-2 pr-4">
          <v-btn icon @click="drawer = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </template>

      <v-list nav flat class="pa-0">
        <div v-for="item in navigationItems" :key="item.title">
          <v-list-item
            :to="item.to"
            :href="item.href"
            :target="item.target"
            @click="drawer = false"
            class="px-6"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
          <v-divider dark></v-divider>
        </div>
      </v-list>

      <template v-slot:append>
        <div v-if="isLoggedIn">
          <v-btn @click="onLogoutClicked" depressed block tile color="primary">
            Logout
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SearchBar from '@/components/SearchBar.vue';

export default {
  name: 'AppBar',
  components: { SearchBar },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  data() {
    return {
      drawer: false,
      searchBarVisible: false,
      navigationItems: [
        { icon: 'mdi-map-marker', title: 'BAUSTELLEN', to: '/baustellen' },
        {
          icon: 'mdi-cart-arrow-down',
          title: 'BESTELLUNGEN',
          to: '/bestellungen',
        },
        { icon: 'mdi-account', title: 'KONTAKT', to: '/kontakt' },
        { icon: 'mdi-earth', title: 'IMPRESSUM', to: '/impressum' },
      ],
    };
  },
  methods: {
    ...mapActions(['userLogout']),
    onDrawerClicked() {
      this.drawer = true;
    },
    onSearchClicked() {
      this.searchBarVisible = !this.searchBarVisible;
    },
    onSearchFinished() {
      this.searchBarVisible = false;
    },
    onLogoutClicked() {
      this.drawer = false;
      this.userLogout();
    },
  },
};
</script>

<style scoped>
.app-bar {
  position: fixed !important;
  z-index: 1000 !important;
}

.app-drawer {
  position: fixed !important;
  z-index: 1001 !important;
}

.drawer-header {
  height: 30vh;
}

.app-bar >>> .v-toolbar__content,
.app-bar >>> .v-toolbar__extension {
  border-bottom: 1px #e9e9e9 solid;
}
</style>
